import React, { useCallback } from "react";
import CandidateInfor from "../component/CandidateInfor/CandidateInfor";
import useBGVerificationUpdateHook from "./BGVerficationUpdateHook";
import { ButtonBase, IconButton, MenuItem } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import styles from "./Style.module.css";
import historyUtils from "../../../libs/history.utils";
import CustomSelectField from "../../../components/FormFields/SelectField/SelectField.component";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import CustomCheckbox from "../../../components/FormFields/CustomCheckbox";
import CustomDatePicker from "../../../components/FormFields/DatePicker/CustomDatePicker";
import { EditOutlined } from "@material-ui/icons";
import BGVStatusTable from "./component/BGVStatusTable/BGVStatusTable";
import DocumentDetailTable from "./component/DocumentDetailTable/DocumentDetailTable";
import StatusPill from "../../../components/Status/StatusPill.component";
import { removeUnderScore } from "../../../helper/helper";
import constants from "../../../config/constants";
import RouteName from "../../../routes/Route.name";
import { useLocation } from "react-router-dom";

const BGVerificationUpdate = () => {
  const {
    form,
    changeTextData,
    errorData,
    handleSubmit,
    isEdit,
    setIsEdit,
    data,
    setData,
    timeline,
  } = useBGVerificationUpdateHook({});
  const renderStatus = useCallback((status) => {
    return <StatusPill status={status} />;
  }, []);
  const location = useLocation();

const detail = location?.state?.detail;

  return (
    <div>
      <div className={styles.outerFlex}>
        <div>
          <ButtonBase
            onClick={() =>
              historyUtils.push(
                detail === "OC"
                  ? RouteName.OLD_PENDING_BACKGROUND_VERIFICATION
                  : RouteName.PENDING_BACKGROUND_VERIFICATION,
              )
            }
          >
            <ArrowBackIosIcon fontSize={"small"} />{" "}
            <span>
              <b>Background Verification Form </b>
            </span>
          </ButtonBase>
          <div className={styles.newLine} />
        </div>
      </div>
      <CandidateInfor empId={form?.emp_code} />
      {data?.bgv_company_status !== "NA" &&
        data?.payment_status !== "NA" &&
        data?.bgv_status !== "NA" && (
          <div className={styles.container}>
            <span className={styles.title}>Background Verification Status</span>

            <div className={styles.tableHeader}>
              <div className={styles.calValue}>VERIFICATION TYPE</div>
              <div className={styles.calValue}>STATUS</div>
              <div className={styles.calValue}>REMARKS</div>
            </div>

            {constants.verificationRows
              .filter((row) => data?.[row.key])
              .map((row, index) => (
                <div
                  key={row.key}
                  className={`${styles.flexRow} ${index % 2 === 0 ? styles.rowOdd : styles.rowEven}`}
                >
                  <div className={styles.calValue}>{row.label}</div>
                  <div className={styles.calValue}>
                    {data?.[row.statusKey]
                      ? renderStatus(removeUnderScore(data[row.statusKey]))
                      : "N/A"}
                  </div>
                  <div className={styles.calValue}>
                    {data?.[row.remarkKey] || "N/A"}
                  </div>
                </div>
              ))}
          </div>
        )}

      {data?.documents &&
        data?.bgv_company_status !== "NA" &&
        data?.payment_status !== "NA" &&
        data?.bgv_status !== "NA" && (
          <DocumentDetailTable data={data?.documents} />
        )}
      {data?.bgv_company_status !== "INPROCESS" &&
        data?.bgv_company_status !== "PENDING" &&
        data?.bgv_company_status !== "NA" &&
        data?.payment_status !== "NA" &&
        data?.bgv_status !== "NA" && (
          <div className={styles.plainPaper}>
            <div className={styles.newContainer}>
              <div className={styles.subheading}>Final BGV Company Remarks</div>

              <div className={styles.finalContainer}>
                <div
                  style={{
                    color: "#161616",
                    fontFamily: "normal normal normal 14px/32px Montserrat",
                    fontSize: "13px",
                  }}
                >
                  {data?.bgv_company_remarks}
                </div>
                <a
                  href={data?.bgv_company_file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  View File
                </a>
                <div className={styles.heading}>
                  {data?.bgv_company?.repersentative_name || "N/A"}{" "}
                  {data?.updatedAtText && " | "}
                  {data?.updatedAtText}
                </div>
              </div>
            </div>
          </div>
        )}
      {data?.bgv_company_status === "COMPLETED" &&
        data?.bgv_status === "INCOMPLETE" && (
          <>
            <div className={styles.plainPaper}>
              <div>
                <div className={styles.subheading}>Final BGV Status </div>
                {/* <div className={styles.gaps} />
          <span>Update Verification Status</span> */}
              </div>
              <div className={styles.newContainer}>
                {/* <div className={styles.mainFlex}>
            <div className={styles.left}>
              <div className={styles.alignOneColoumn}>
                <div className={styles.InnerWrap}>
                  <div className={styles.formGroup}>
                    <CustomCheckbox
                      color={"primary"}
                      label={"Education"}
                      disabled={
                        form?.is_education_verification
                          ? form?.is_education_verification
                          : !form?.is_education_verification
                      }
                      checked={form?.is_education_verification}
                    />
                  </div>
                </div>
                <div className={"formGroup"} id={styles.minWidth}>
                  {form?.is_education_verification && (
                    <CustomSelectField
                      isError={errorData?.is_education_verification_status}
                      errorText={errorData?.is_education_verification_status}
                      label={"Choose Status"}
                      value={form?.is_education_verification_status}
                      handleChange={(value) => {
                        changeTextData(
                          value,
                          "is_education_verification_status"
                        );
                      }}
                    >
                      <MenuItem value="CLEAR">Clear</MenuItem>
                      <MenuItem value="FAILED">Failed </MenuItem>
                      <MenuItem value="UNABLE_TO_VERIFY">
                        Unable to Verify
                      </MenuItem>
                      <MenuItem value="PENDING">Pending</MenuItem>
                    </CustomSelectField>
                  )}
                </div>
              </div>
              <div className={styles.alignOneColoumn}>
                <div className={styles.InnerWrap}>
                  <div className={styles.formGroup}>
                    <CustomCheckbox
                      color={"primary"}
                      disabled={
                        form?.is_first_employment_verification
                          ? form?.is_first_employment_verification
                          : !form?.is_first_employment_verification
                      }
                      label={"1st Employment"}
                      checked={form?.is_first_employment_verification}
                    />
                  </div>
                </div>
                <div className={"formGroup"} id={styles.minWidth}>
                  {form?.is_first_employment_verification && (
                    <CustomSelectField
                      isError={
                        errorData?.is_first_employment_verification_status
                      }
                      errorText={
                        errorData?.is_first_employment_verification_status
                      }
                      label={"Choose Status"}
                      value={form?.is_first_employment_verification_status}
                      handleChange={(value) => {
                        console.log(value);
                        changeTextData(
                          value.toUpperCase(),
                          "is_first_employment_verification_status"
                        );
                      }}
                    >
                      <MenuItem value="CLEAR">Clear</MenuItem>
                      <MenuItem value="FAILED">Failed </MenuItem>
                      <MenuItem value="UNABLE_TO_VERIFY">
                        Unable To Verify{" "}
                      </MenuItem>
                      <MenuItem value="PENDING">Pending</MenuItem>
                    </CustomSelectField>
                  )}
                </div>
              </div>
              <div className={styles.alignOneColoumn}>
                <div className={styles.InnerWrap} id={styles.minWidth}>
                  <div className={styles.formGroup}>
                    <CustomCheckbox
                      color={"primary"}
                      disabled={
                        form?.is_secound_employment_verification
                          ? form?.is_secound_employment_verification
                          : !form?.is_secound_employment_verification
                      }
                      label={"2nd Employment"}
                      checked={form?.is_secound_employment_verification}
                    />
                  </div>
                </div>
                <div className={"formGroup"} id={styles.minWidth}>
                  {form?.is_secound_employment_verification && (
                    <CustomSelectField
                      isError={
                        errorData?.is_secound_employment_verification_status
                      }
                      errorText={
                        errorData?.is_secound_employment_verification_status
                      }
                      label={"Choose Status"}
                      value={form?.is_secound_employment_verification_status}
                      handleChange={(value) => {
                        changeTextData(
                          value,
                          "is_secound_employment_verification_status"
                        );
                      }}
                    >
                      <MenuItem value="CLEAR">Clear</MenuItem>
                      <MenuItem value="FAILED">Failed </MenuItem>
                      <MenuItem value="UNABLE_TO_VERIFY">
                        Unable To Verify{" "}
                      </MenuItem>
                      <MenuItem value="PENDING">Pending</MenuItem>
                    </CustomSelectField>
                  )}
                </div>
              </div>
              <div className={styles.alignOneColoumn}>
                <div className={styles.InnerWrap}>
                  <div className={styles.formGroup}>
                    <CustomCheckbox
                      color={"primary"}
                      disabled={
                        form?.is_criminal_verification
                          ? form?.is_criminal_verification
                          : !form?.is_criminal_verification
                      }
                      label={"Criminal"}
                      checked={form?.is_criminal_verification}
                    />
                  </div>
                </div>
                <div className={"formGroup"} id={styles.minWidth}>
                  {form?.is_criminal_verification ? (
                    <CustomSelectField
                      isError={errorData?.is_criminal_verification_status}
                      errorText={errorData?.is_criminal_verification_status}
                      label={"Choose Status"}
                      value={form?.is_criminal_verification_status}
                      handleChange={(value) => {
                        changeTextData(
                          value,
                          "is_criminal_verification_status"
                        );
                      }}
                    >
                      <MenuItem value="CLEAR">Clear</MenuItem>
                      <MenuItem value="FAILED">Failed </MenuItem>
                      <MenuItem value="UNABLE_TO_VERIFY">
                        Unable To Verify{" "}
                      </MenuItem>
                      <MenuItem value="PENDING">Pending</MenuItem>
                    </CustomSelectField>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
          </div> */}
                <div className={"formFlex"}>
                  <div className={"formGroup"}>
                    <CustomSelectField
                      isError={errorData?.bgv_result}
                      errorText={errorData?.bgv_result}
                      label={"Choose BGV Result Status"}
                      value={form?.bgv_result}
                      handleChange={(value) => {
                        changeTextData(value, "bgv_result");
                      }}
                      disabled={
                        data?.bgv_result !== "PENDING" &&
                        data?.bgv_result !== "INPROCESS"
                      }
                    >
                      <MenuItem value="PENDING">Pending </MenuItem>
                      <MenuItem value="FAILED">Failed </MenuItem>
                      <MenuItem value="CLEAR">Clear </MenuItem>
                      <MenuItem value="INPROCESS">In Process</MenuItem>
                    </CustomSelectField>
                  </div>
                </div>

                <div className={styles.requiredFooter}>
                  <div className={styles.topText}>
                    <b>BGV Status: {form?.bgv_status}</b>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.plainPaper}>
              <div>
                <div className={styles.subheading}>
                  Required Action Details{" "}
                </div>
              </div>
              <div className={styles.newContainer}>
                <div className={"formFlex"}>
                  <div className={"formGroup"}>
                    <CustomSelectField
                      isError={errorData?.choose_action}
                      errorText={errorData?.choose_action}
                      label={"Choose Action "}
                      value={form?.choose_action}
                      handleChange={(value) => {
                        changeTextData(value, "choose_action");
                      }}
                    >
                      <MenuItem value="TERMINATED">Terminated</MenuItem>
                      <MenuItem value="ALLOWED_TO_WORK">
                        Allowed to work{" "}
                      </MenuItem>
                      <MenuItem value="NA">N/A</MenuItem>
                    </CustomSelectField>
                  </div>
                </div>

                <div className={"formFlex"}>
                  <div className={"formGroup"}>
                    <CustomTextField
                      // isError={errorData?.description}
                      // errorText={errorData?.description}
                      label={"Any Remarks"}
                      value={form?.action_remark}
                      onTextChange={(text) => {
                        changeTextData(text, "action_remark");
                      }}
                      // onBlur={() => {
                      //    onBlurHandler("remark");
                      // }}
                      multiline
                      rows={3}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.plainPaper}>
              <div className={styles.newContainer}>
                <div className={"formFlex"}>
                  <div style={{ color: "#161616", fontSize: "15px" }}>
                    <b> Payment Details</b>
                  </div>
                </div>
                <div className={styles.billingWrap}>
                  <span>
                    <b>Billing To:</b>{" "}
                    <span className={styles.right_gaps}>
                      {" "}
                      {form?.billing_to}
                    </span>
                  </span>
                </div>

                <div className={styles.formFlex}>
                  <div className={"formGroup"}>
                    <div className={styles.Wrap}>
                      <div style={{ flex: "1" }}>
                        <CustomTextField
                          isError={errorData?.cost}
                          errorText={errorData?.cost}
                          label={"Cost"}
                          type={"number"}
                          value={form?.cost}
                          disabled={!isEdit || !form?.choose_action}
                          onTextChange={(text) => {
                            changeTextData(text, "cost");
                          }}
                        />
                      </div>
                      <div>
                        <IconButton
                          className={"tableActionBtn"}
                          color="secondary"
                          onClick={() => setIsEdit(true)}
                        >
                          <EditOutlined fontSize={"small"} />
                        </IconButton>
                      </div>
                    </div>
                    <CustomSelectField
                      isError={errorData?.payment_status}
                      errorText={errorData?.payment_status}
                      label={"Payment Status "}
                      value={form?.payment_status}
                      disabled={!form?.choose_action}
                      handleChange={(value) => {
                        changeTextData(value, "payment_status");
                      }}
                    >
                      <MenuItem value="INPROCESS">In Process</MenuItem>
                      <MenuItem value="CLEAR">Clear </MenuItem>
                      <MenuItem value="PENDING">Pending </MenuItem>
                    </CustomSelectField>
                  </div>
                  <div className={"formGroup"}>
                    <CustomDatePicker
                      clearable
                      label={"Complete in "}
                      disabled={!form?.choose_action}
                      maxDate={new Date()}
                      onChange={(value) => {
                        changeTextData(value, "payment_complete");
                      }}
                      views={["month", "year"]}
                      format={"MM-yyyy"}
                      value={form?.payment_complete}
                      isError={errorData?.payment_complete}
                      errorText={errorData?.payment_complete}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      {data?.bgv_company_status === "COMPLETED" &&
        data?.payment_status === "CLEAR" &&
        data?.bgv_status === "COMPLETED" && (
          <>
            <div className={styles.plainPaper}>
              <div className={styles.newContainer}>
                <div className={styles.heading}>Final BGV Status</div>
                <div className={styles.candidateContainer}>
                  <div className={styles.left}>
                    <div className={styles.key}>
                      <span className={styles.value}>BGV Status:</span>
                      {data?.bgv_status
                        ? renderStatus(removeUnderScore(data?.bgv_status))
                        : "N/A"}
                    </div>
                  </div>
                  <div className={styles.right}>
                    <div className={styles.key}>
                      <span className={styles.value}>BGV Result:</span>
                      {data?.bgv_result
                        ? renderStatus(removeUnderScore(data?.bgv_result))
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.plainPaper}>
              <div className={styles.newContainer}>
                <div className={styles.heading}>Required Action Details</div>
                <div className={styles.candidateContainer}>
                  <div className={styles.key}>
                    <span className={styles.value}>Action Choosen:</span>
                    {removeUnderScore(data?.choose_action) || "N/A"}
                  </div>
                </div>
                <div className={styles.key}>
                  <span className={styles.value}>Remarks:</span>
                  {data?.action_remark || "N/A"}
                </div>
              </div>
            </div>
            <div className={styles.plainPaper}>
              <div className={styles.newContainer}>
                <div className={styles.heading}>Payment Details</div>
                <div className={styles.candidateContainer}>
                  <div className={styles.left}>
                    <div className={styles.key}>
                      <span className={styles.value}>Cost:</span>
                      {data?.cost ? `₹ ${data.cost}` : "N/A"}
                    </div>
                    <div className={styles.key}>
                      <span className={styles.value}>Payment Status:</span>
                      {data?.payment_status || "N/A"}
                    </div>
                  </div>
                  <div className={styles.right}>
                    <div className={styles.key}>
                      <span className={styles.value}>Billing To:</span>
                      {data?.billing_to || "N/A"}
                    </div>
                    <div className={styles.key}>
                      <span className={styles.value}>Completed In:</span>
                      {data?.paymentCompleteText || "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      {data?.bgv_company_status !== "INPROCESS" &&
        data?.bgv_company_status !== "PENDING" &&
        data?.bgv_company_status !== "NA" &&
        data?.payment_status !== "NA" &&
        data?.bgv_status !== "NA" && (
          <div className={styles.plainPaper}>
            <div className={styles.newContainer}>
              <div className={"formFlex"}>
                <div style={{ color: "#161616", fontSize: "15px" }}>
                  <b> Remarks</b>
                </div>
              </div>
              <p
                style={{
                  color: "#161616",
                  fontFamily: "normal normal normal 14px/32px Montserrat",
                  fontSize: "13px",
                }}
              >
                {form?.remark}
              </p>
            </div>
          </div>
        )}
      <div className={styles.plainPaper}>
        <div className={styles.newContainer}>
          <div className={styles.heading}>Timeline</div>
          <div
            dangerouslySetInnerHTML={{
              __html: (data?.rehired_remarks || "").replace(/\n/g, "<br/>"),
            }}
          ></div>

          {timeline.map((item) => (
            <div className={styles.documentContainer}>
              {!data?.rehired_remarks && (
                <div className={styles.status}>
                  {
                    <StatusPill
                      status={removeUnderScore(item?.event)}
                      style={{ border: "none", backgroundColor: "transparent" }}
                    />
                  }
                </div>
              )}
              <div className={styles.heading}>
                {item?.update_by_name || "N/A"} {item?.createdAtText && " | "}
                {item?.createdAtText}
              </div>
            </div>
          ))}
        </div>
      </div>

      {data?.bgv_company_status === "COMPLETED" &&
        data?.bgv_status === "INCOMPLETE" && (
          <div className={styles.btnCont}>
            <ButtonBase
              type={"button"}
              onClick={handleSubmit}
              className={styles.createBtn}
            >
              UPDATE
            </ButtonBase>
          </div>
        )}
    </div>
  );
};

export default BGVerificationUpdate;
